import RecurringProphyStudy from './studyConfig/RecurringProphyStudy'

export default new RecurringProphyStudy({
  molecule: 'Fremanezumab',
  smallText: 'e.g. Ajovy',
  dosageOptions: [
    '225mg monthly',
    '675mg every 3 months'
  ]
})



// WEBPACK FOOTER //
// ./src/store/recurring/recurringProphyFremanezumab.js